// extracted by mini-css-extract-plugin
export default {"skeleton":"CategoriesChipList_skeleton__VsaBA","popoverContent":"CategoriesChipList_popoverContent__Otceo","contacts":"CategoriesChipList_contacts__ffUtf"};